import { eventBus, domEvents, withPlugins } from '@spon/plugins';
import { animate } from 'motion';

function Navigation({ node, plugins: { addEvents } }) {
	const hoverItems = [...node.querySelectorAll('[data-hover-menu="true"]')];
	const background = document.querySelector('[data-menu-bg]');

	const animateBg = event => {
		let height = 1;

		if (event.target.closest('[data-top-level-menu-item]')) {
			const topLevelMenuItem = event.target.closest(
				'[data-top-level-menu-item]'
			);
			const submenu = topLevelMenuItem.querySelector('[data-submenu]');

			// Your code here
			if (submenu) {
				height = submenu.offsetHeight ?? 0;
			}
		}

		animate(background, {
			height: height + 'px',
			duration: 0.2,
			delay: 0,
			ease: 'linear',
		});
	};

	const animateBgOut = () => {
		log('hover');

		animate(background, {
			height: '0px',
			duration: 0.2,
			delay: 0,
			ease: 'linear',
		});
	};

	hoverItems.forEach(item => {
		item.addEventListener('mouseover', animateBg);
		item.addEventListener('mouseleave', animateBgOut);
	});

	return () => {};
}

export default withPlugins(domEvents)(Navigation);
